<template>
  <div class="login-card">
    <div class="login-card-header">
      <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
      <span>Acessar</span>
    </div>
    <div class="login-card-body">
      <div class="alert alert-danger" v-show="error != ''">
        <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>
        {{ error }}
      </div>

      <div class="form-group">
        <label>Login</label>
        <input
          type="text"
          class="form-control"
          v-model="user.email"
          placeholder="Login"
          autofocus
        />
      </div>

      <div class="form-group">
        <label>Senha</label>
        <input
          type="password"
          class="form-control"
          v-model="user.password"
          placeholder="Senha"
          @keyup.enter="onSubmit"
        />
      </div>

      <div class="d-flex justify-content-between align-items-center mt-2">
        <router-link to="/forgot-password" class="forgot-link">
          Esqueci minha senha
        </router-link>
        <button class="btn-login" @click="onSubmit" :disabled="loading">
          <font-awesome-icon :icon="['fas', 'sign-in-alt']"></font-awesome-icon>
          Login
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'

  export default {
    setup() {
      const error = ref('')
      const loading = ref(false)
      const router = useRouter()
      const store = useStore()
      const user = ref({
        email: '',
        password: '',
      })

      const onSubmit = () => {
        if (loading.value) return
        error.value = ''
        loading.value = true

        store
          .dispatch('login', user)
          .then(() => {
            router.push('/')
          })
          .catch(({ response }) => {
            const { data } = response
            error.value = data.error ? data.error : 'Credenciais inválidas'
          })
          .finally(() => {
            loading.value = false
          })
      }

      return {
        error,
        loading,
        onSubmit,
        user,
      }
    },
  }
</script>
